import { insertDocMessage } from "./useInsertDoc";

export const uploadFilesSequentially = async ({ files, transactionId, uploadPathHeader, onProgress }) => {
  const results = [];

  for (const file of files) {
    if (!(file instanceof File)) {
      results.push(null);
      continue;
    }

    const res = await insertDocMessage(file, transactionId, uploadPathHeader, (p) => {
      onProgress?.(p);
    });
    results.push(res);
  }

  return results;
};
